
































import Vue from "vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    MaterialIcon,
  },
  props: {
    placeholder: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      focused: false,
    }
  },
  computed: {
    iconType() {
      return { OUTLINED }
    },
  },
  methods: {
    toFocused(): void {
      this.focused = true
    },
    toUnfocused(): void {
      this.focused = false
    },
    handleInput(event: any): void {
      this.$emit("input", event.target.value || "")
    },
    handleChange(event: any): void {
      this.$emit("input", event.target.value || "")
    },
    handlePressEnter(event: any): void {
      // 日本語入力中のEnterキー操作を無効にする
      if (event.keyCode !== 13) return
      this.$emit("enter")

      if (this.$device.isMobile) {
        // 入力中のフォームからフォーカス外す
        const textFieldElement = this.$refs.textField as HTMLElement
        textFieldElement.blur()
      }
    },
    handleClick(): void {
      if (this.isReadOnly) this.$emit("click-text-field-when-read-only")
    },
  },
})
